import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import RejectHandshakeModal from './reject_handshake_modal';
import Modal from 'components/general/modal/modal';
import Textarea from 'components/form/textarea/textarea';
import RadioButtons from 'components/form/radio_buttons/radio_buttons';

let props;
let wrapped: ShallowWrapper;

window.Routes = {
  job_ad: () => '',
  reject_dashboard_handshake: () => '',
};

const createProps = () => {
  return {
    handshake: jest.fn(),
    companyName: 'Dr.Oak Industries',
    jobAd: { title: 'Pokemon Master', id: 177013 },
    setIsModalOpen: jest.fn(),
    hasFollowUpModal: true,
    rejectReasons: {
      remote_only: 'Only looking for remote positions',
      location_mismatch: "The job's location doesn't work for me",
      other: "Other",
    },
  };
};

describe('RejectHandshakeModal', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<RejectHandshakeModal {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });

  it('contains a Modal', () => {
    expect(wrapped.find(Modal).length).toEqual(1);
  });

  it('contains radio buttons', () => {
    expect(wrapped.find(RadioButtons).length).toEqual(1);
  });

  it('shows the textarea only when "other" is selected', () => {
    expect(wrapped.find(Textarea).length).toEqual(0);

    wrapped.find(RadioButtons).prop('onChange')('other');
    wrapped.update();

    expect(wrapped.find(Textarea).length).toEqual(1);
  });

  it('contains a link', () => {
    expect(wrapped.find('a').length).toEqual(1);
  });
});
